import { AddRounded, AutoAwesomeRounded, KeyboardArrowUp, PersonRounded } from "@mui/icons-material";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { grey, yellow } from "@mui/material/colors";
import {
	attrConditionalDisplayColObj,
	attrGroupLinkedTables,
	attrGrpTableStrColumnsObj,
	attrTableStrColumnsObj,
	colorImagesAssocObj,
	constraintsOptions,
	isColumnDefault,
	productionStageOptions,
	productPagePath,
	styleColorAssocObj,
	styleFileAssocObj,
	styleImagesAssocObj,
} from "components/PimDashboard/data";
import { AuthState } from "context/AuthContext";
import { PimDashboardState } from "context/PimDashboardContext";
import { arrType, datatypes, inputTypes, statusOptions } from "data/globalData";
import { attrGrpAttrAssocObj, attrValAssocObj } from "../DesignerAttributes/data";
import { useMemo, useState } from "react";
import axios from "axios";
import RenderAttributeInputs from "./RenderAttributes/RenderAttributeInputs";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import ColorsSection from "./ColorsSection/ColorsSection";
import AddNewImageModal, { isMainImg } from "./AddImagesModal/AddImagesModal";
import { getColDefaultValue } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { departments, rootProtectedPath } from "data/authData";
import { useNavigate } from "react-router-dom";
import { NAOption, styleFileColumns, styleFileUrlKey, styleImgDepartmentCol, styleUrlKey } from "./data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import AddFiles, { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
import { validateMandatoryFields } from "utils/mandatoryFieldsLogic";
import RenderConditionalAttributeInputs from "./RenderConditionalAttributes/RenderConditionalAttributeInputs";
import SuggestAttributesModal from "./SuggestAttributesModal/SuggestAttributesModal";
const imgWidth = 220;
const imgHeight = 280;
const CreateStyle = () => {
	const { user } = AuthState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr, allAttributes, setSelectedStyle } = PimDashboardState();
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();

	const navigate = useNavigate();

	const [newStyleDetails, setNewStyleDetails] = useState(() => {
		let obj = {};
		allAttributes.forEach((attr) => {
			if (!obj[attr?.linked_table]) obj[attr?.linked_table] = {};
			obj[attr?.linked_table][attr?.key] = getColDefaultValue(attr);
		});
		return obj;
	});
	const [pageFiles, setPageFiles] = useState([]);
	const [errobj, setErrorObj] = useState({});
	const [images, setImages] = useState([]);
	const [colors, setColors] = useState([]);
	const [imgModalOpen, setImgModalOpen] = useState(false);
	const [suggestModalOpen, setSuggestModalOpen] = useState(false);
	const handleAddImageClick = () => {
		setImgModalOpen(true);
	};
	const handleSaveImgClick = (Images) => {
		setImages([...Images]);
		return true;
	};
	const handleFileUpload = async (styleImages, colors, pageFiles) => {
		// append formdata with multiple file and its name

		const uploadStyleColorImgs = async () => {
			const formData = new FormData();
			styleImages?.forEach((image) => {
				formData.append("styleImages", image.file);
			});
			colors?.forEach((image) => {
				formData.append("colorImages", image.file);
			});
			const res = await axios.post("/api/designer/upload_style_col_images", formData, {
				headers: {
					"content-type": "multipart/form-data",
				},
			});

			return [res.data.styleImageUrls, res.data.colorImageUrls];
		};
		const uploadStyleFiles = async () => {
			if (pageFiles?.length) {
				const fileFormData = new FormData();

				pageFiles?.forEach((fileData) => {
					fileFormData.append("files", fileData[fileColumn.key]);
					fileFormData.append("fileMeta", JSON.stringify(fileData)); // corresponding metadata
				});
				const res = await axios.post("/api/upload/multiple_upload_to_rel_bucket", fileFormData, {
					headers: {
						"content-type": "multipart/form-data",
					},
				});
				return res.data.result;
			}
			return new Promise((resolve, reject) => {
				resolve([]);
			});
		};
		const [styleColorImgs, uploadedFiles] = await Promise.all([uploadStyleColorImgs(), uploadStyleFiles()]);

		return [...styleColorImgs, uploadedFiles];
	};

	const handleFormSubmit = async () => {
		setLoadingOpen(true);
		if (images.length === 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Add atleast one image",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		if (colors.length === 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Add atleast one color",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		const brand = newStyleDetails[attrGroupLinkedTables.style.key]?.brand || "";
		const category = newStyleDetails[attrGroupLinkedTables.style.key]?.department || "";

		const styleAttrs = allAttributes.filter(
			(row) => row?.linked_table === attrGroupLinkedTables.style.key && row?.input_type !== inputTypes.AUTO_GENERATE.key,
		);

		const validation = validateMandatoryFields(newStyleDetails, styleAttrs, brand, category, attrGroupLinkedTables.style.key);

		const pendingFields = validation.missingFields;

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}

		const sysData = {
			last_updated_by: user?.email,
			created_by: user?.email,
			stage: productionStageOptions.DESIGNER.key,
			status: statusOptions.DESIGNER_PENDING.key,
		};

		try {
			let [styleImages, colorImages, uploadedFiles] = await handleFileUpload(images, colors, pageFiles);

			// finding main Img Url
			images.forEach((row, i) => {
				if (row[isMainImg] === true) {
					styleImages[i][isMainImg] = true;
					styleImages[i]["url"] = styleImages[i]["publicUrl"];
				}
			});
			colorImages = colorImages.map((row) => {
				return { url: row.publicUrl };
			});
			uploadedFiles = uploadedFiles.map((row) => {
				let dup = { ...row };
				delete dup["id"];
				return dup;
			});

			const colorsArr = [];
			colors.forEach((colorData, i) => {
				let obj = {};
				// filtering unnecessay object keys
				allAttributes
					.filter((row) => row?.linked_table === attrGroupLinkedTables.color.key)
					.forEach((attr) => {
						obj[attr.key] = colorData[attr.key];
					});
				colorsArr.push({ ...obj, ...sysData });
			});

			const body = newStyleDetails;
			// for joining color & images

			body[attrGroupLinkedTables.color.key] = colorsArr;
			// for joining style & images
			body[attrGroupLinkedTables.style.key] = {
				...body[[attrGroupLinkedTables.style.key]],
				...sysData,
				[styleImagesAssocObj]: styleImages,
				[styleFileAssocObj]: uploadedFiles,
			};
			body[colorImagesAssocObj] = colorImages;

			const res = await axios.post("/api/designer/create_style", body);
			setSelectedStyle();
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Style created successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			navigate(`/${productPagePath}?${styleUrlKey}=${res.data.style_id}`);
			setLoadingOpen(false);
		} catch (error) {
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
		}
	};

	const handleDesignerFileAdd = async (newFileData) => {
		setPageFiles((prev) => [...prev, { ...newFileData, [styleFileUrlKey]: "To be Uploaded" }]);

		return true;
	};

	async function handleDesignerFileDelete(fileData) {
		setPageFiles((prev) => prev.filter((row) => row?.id !== fileData?.id));

		return true;
	}

	const styleAttrs = useMemo(
		() =>
			allAttributes.filter(
				(row) => row?.linked_table === attrGroupLinkedTables.style.key && row?.input_type !== inputTypes.AUTO_GENERATE.key,
			),
		[allAttributes],
	);

	const brand = newStyleDetails[attrGroupLinkedTables.style.key]?.brand || "";
	const category = newStyleDetails[attrGroupLinkedTables.style.key]?.department || "";
	const styleMainDetailsValidation = validateMandatoryFields(
		newStyleDetails,
		styleAttrs,
		brand,
		category,
		attrGroupLinkedTables.style.key,
	);
	const mainImage = images.find((row) => row?.[isMainImg]) || images?.[0];
	const canSuggestAttributes = Boolean(mainImage?.file) && styleMainDetailsValidation.missingFields.length === 0;
	const suggestAttributesHelperText = !mainImage?.file
		? "Select a main image first to get suggested attributes."
		: styleMainDetailsValidation.missingFields.length > 0
			? `Fill main details first: ${styleMainDetailsValidation.missingFields.map((row) => row?.name).join(", ")}`
			: "";
	const styleGroups = useMemo(
		() =>
			Object.keys(attrGroupsWithAttr).reduce((acc, row) => {
				if (attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] === attrGroupLinkedTables.style.key) {
					acc.push(attrGroupsWithAttr[row]);
				}
				return acc;
			}, []),
		[attrGroupsWithAttr],
	);

	return (
		<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
			<Stack>
				<Box display="flex" columnGap={1}>
					<Typography variant="subtitle1">User :</Typography>
					<PersonRounded />
					<Typography variant="subtitle1">{user.name}</Typography>
				</Box>
			</Stack>
			<Box
				display="flex"
				alignItems="center"
				height="30px"
				columnGap={1}
				sx={{
					backgroundColor: statusOptions["NEW"]?.color || yellow[400],
					color: "white",
					padding: "5px",
					borderRadius: "5px",
				}}>
				{statusOptions["NEW"]?.icon} <Typography> {statusOptions["NEW"]?.name}</Typography>
			</Box>

			{/* style Table Columns */}

			<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1, mb: 1 }} />
			<Box display="flex" justifyContent="space-around" width="100%">
				{/* left */}
				<Stack>
					<Box display="flex" width="100%" pb={1} justifyContent="space-between">
						<Typography variant="h6">Images</Typography>
						{images?.length > 0 && (
							<Button
								sx={{ textTransform: "capitalize" }}
								onClick={handleAddImageClick}
								size="small"
								startIcon={<AddRounded />}
								variant="outlined">
								Add / Set Main Images
							</Button>
						)}
					</Box>
					<Box
						width={imgWidth}
						height={imgHeight}
						sx={{ border: `1px solid ${grey[200]}` }}
						display="flex"
						alignItems="center"
						justifyContent="center">
						{images.length === 0 ? (
							<Box>
								<Button size="large" startIcon={<AddRounded />} onClick={handleAddImageClick}>
									Add Images
								</Button>
							</Box>
						) : (
							<Box width={imgWidth} height={imgHeight} display="flex" flexWrap="wrap" rowGap={2}>
								<ImageSlider imgWidth={imgWidth} imgHeight={imgHeight} column="url" images={images} />
							</Box>
						)}
						{/* */}
					</Box>
				</Stack>
				<Divider orientation="vertical" flexItem />
				{/* right */}
				<Box sx={{ width: "76%" }}>
					{styleGroups?.map((row, index) => {
						const isMainDetailsSection = row?.is_main === true || index === 0;
						return (
							<Box width="100%" pt={2}>
								<Typography variant="h6">{row[attrGrpTableStrColumnsObj.name.key]}</Typography>
								{row?.data?.[attrConditionalDisplayColObj.key] ? (
									<RenderConditionalAttributeInputs
										columns={[...row[attrGrpAttrAssocObj]]}
										setData={setNewStyleDetails}
										data={newStyleDetails}
										attrGrp={row}
										errObj={errobj}
										setErrorObj={setErrorObj}
										itemWidth="32%"
									/>
								) : (
									<RenderAttributeInputs
										columns={[...row[attrGrpAttrAssocObj]]}
										setData={setNewStyleDetails}
										data={newStyleDetails}
										attrGrp={row}
										errObj={errobj}
										setErrorObj={setErrorObj}
										itemWidth="32%"
									/>
								)}
								{isMainDetailsSection && (
									<Box mt={2} display="flex" flexDirection="column" alignItems="flex-start">
										<Button
											onClick={() => setSuggestModalOpen(true)}
											variant="contained"
											startIcon={<AutoAwesomeRounded />}
											disabled={!canSuggestAttributes}
											sx={{
												textTransform: "none",
												fontWeight: 700,
												background: "linear-gradient(90deg, #2563eb 0%, #3b82f6 100%)",
												color: "#eff6ff",
												boxShadow: "0 8px 20px rgba(37,99,235,0.28)",
												"&:hover": {
													background: "linear-gradient(90deg, #1d4ed8 0%, #2563eb 100%)",
												},
											}}>
											Suggest Attributes
										</Button>
										{suggestAttributesHelperText && (
											<Typography variant="caption" color="error" display="block" pt={1.25}>
												{suggestAttributesHelperText}
											</Typography>
										)}
									</Box>
								)}
							</Box>
						);
					})}
				</Box>
			</Box>
			<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />
			<ColorsSection colors={colors} setColors={setColors} styleData={newStyleDetails} />
			{/* style Details Table Columns */}
			{Object.keys(attrGroupsWithAttr)
				.reduce((acc, row) => {
					if (
						attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] === attrGroupLinkedTables.style_details.key
					)
						if (row === "fabric_details")
							acc.push({
								...attrGroupsWithAttr[row],
								[attrGrpAttrAssocObj]: attrGroupsWithAttr[row][attrGrpAttrAssocObj].map((row) => ({
									...row,
									input_type: inputTypes.AUTO_GENERATE.key,
								})),
							});
						else acc.push(attrGroupsWithAttr[row]);
					return acc;
				}, [])
				.sort((a, b) => a.sort_no - b.sort_no)
				?.map((row) => {
					return (
						<Box width="100%" pt={2}>
							<Typography variant="h6">{row[attrGrpTableStrColumnsObj.name.key]}</Typography>
							{row?.data?.[attrConditionalDisplayColObj.key] ? (
								<RenderConditionalAttributeInputs
									columns={[...row[attrGrpAttrAssocObj]]}
									setData={setNewStyleDetails}
									data={newStyleDetails}
									attrGrp={row}
									errObj={errobj}
									setErrorObj={setErrorObj}
								/>
							) : (
								<RenderAttributeInputs
									columns={[...row[attrGrpAttrAssocObj]]}
									setData={setNewStyleDetails}
									data={newStyleDetails}
									attrGrp={row}
									errObj={errobj}
									setErrorObj={setErrorObj}
								/>
							)}
						</Box>
					);
				})}

			{/* <Divider flexItem orientation="horizontal" sx={{ width: "100%", mt: 2 }} /> */}
			{/* files Section */}
			<Box pt={"20px"} />
			<AddFiles
				addNewDefault={{ [styleImgDepartmentCol.key]: departments.DESIGNER.key }}
				columns={styleFileColumns}
				handleAddFile={handleDesignerFileAdd}
				files={pageFiles}
				setFiles={setPageFiles}
				handleDelete={handleDesignerFileDelete}
			/>

			{/* <Divider flexItem orientation="horizontal" sx={{ width: "100%" }} /> */}

			{/* Submit Button */}
			<Box width="100%" display="flex" justifyContent="center" pb={2} pt={2}>
				<Button onClick={handleFormSubmit} variant="contained" margin="auto" size="large">
					Create Style
				</Button>
			</Box>

			{/* add Images Modal */}
			{imgModalOpen && (
				<AddNewImageModal
					modalOpen={imgModalOpen}
					setModalOpen={setImgModalOpen}
					submitFunction={handleSaveImgClick}
					defaultImages={images}
				/>
			)}
			{suggestModalOpen && (
				<SuggestAttributesModal
					open={suggestModalOpen}
					onClose={() => setSuggestModalOpen(false)}
					baseData={newStyleDetails}
					setBaseData={setNewStyleDetails}
					mainImageFile={mainImage?.file}
				/>
			)}
		</Box>
	);
};

export default CreateStyle;
